<template>
    <div class="main">
        <!-- <el-alert title="该企业还未绑定CA证书" v-if="!bindCaFlag" type="error" show-icon="true" effect="dark" :center="true">
    </el-alert> -->

        <!-- banner -->
        <div class="banner_tool">
            <el-carousel trigger="click" height="35vw" v-if="banners.length != 0">
                <el-carousel-item v-for="(item, index) in banners" :key="index">
                    <el-image :src="item.filePath" style="width:100vw ;" @click="isSkip(item)"></el-image>
                </el-carousel-item>
            </el-carousel>

            <div class="contantMainClass">
                <!-- 通知公告 -->
                <div class="mainTop">
                    <div class="topLeft">
                        <img src="@/assets/images/001.png" />
                        <div class="noticeBoxClass">
                            <div v-for="item in noticeList" class="noticeItemClass" @click="toNoticeDetail(item)">
                                <div class="dotClass"></div>
                                <div class="noticeItemInfo">
                                    <div class="infoClass multi-line">{{ item.title }}</div>
                                    <div class="timeClass">{{ item.updateTime }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="topRight">
                        <div class="dataItem" v-for="(item, index) in dataLable">
                            <div class="dataTitle">
                                <img :src="require(`@/assets/images/data_${index + 1}.png`)" />
                                <div class="title">{{ item.lable }}</div>
                            </div>
                            <div class="dataNum" :style="{ color: item.color }">
                                <!-- {{ item.num }}{{ item.unit }} -->
                                <NumberRoller :fractionDigits="item.fractionDigits"
                                    :iSNumberFormat="item.iSNumberFormat" :color="item.color" :value="item.num"
                                    :duration="5000" :suffix="item.unit" />
                            </div>
                        </div>
                    </div>
                </div>


                <!-- 公告 -->
                <div class="noticeContantClass">
                    <div class="tabsBox">
                        <template v-for="(item, index) in tabPaneList">
                            <!-- v-if="(item.isLogin && access_token) ||  !item.isLogin" -->
                            <div :class="['tabsItemBox', tabPaneName == item.name ? 'activeClass' : '']"
                                @click="tabClick(item)">
                                <img v-if="tabPaneName != item.name"
                                    :src="require(`@/assets/images/btn${index + 1}.png`)">
                                <img v-if="tabPaneName == item.name"
                                    :src="require(`@/assets/images/btn${index + 1}s.png`)">
                                <span class="lableClass">{{ item.label }}</span>
                            </div>
                        </template>
                    </div>
                    <div class="noticeInfoBoxClass">
                        <div v-for="item in dataList" class="noticeItemBoxInfo" @click="onInfo(item)">
                            <div class="leftBox">
                                <div class="infoBox multi-line">{{ item.title }}</div>
                                <div class="bottomClass">
                                    <!-- <div v-if="tabPaneName == 6" class="tagClass">
                                        {{ dictionaryData[item.supplyType] }}
                                    </div> -->
                                    <div v-if="tabPaneName == 6 && item.supplyTypeNames" class="tagClass"
                                        v-for="(curTag, tagIndex) in (item.supplyTypeNames || '').split(';')"
                                        :key="tagIndex">
                                        {{ curTag }}
                                    </div>
                                    <div v-if="tabPaneName == 6 && item.supplySort" class="supportTagClass">
                                        {{ item.supplySort }}
                                    </div>
                                    <!-- <div class="timeBox">{{ item.createTime }}</div> -->
                                </div>
                                <div class="timeBox">{{ item.createTime }}</div>
                            </div>
                            <div v-if="tabPaneName == 6" class="statusBoxClass" :data-status="item.status">
                                {{ statusList[item.status] }}
                            </div>
                        </div>
                    </div>

                    <div v-if="!dataCount" class="emptyClass">暂无数据</div>
                    <div v-if="dataCount" class="paginationClass">
                        <el-pagination background layout="pager" :page-size="6" @current-change="getDataList"
                            :current-page.sync="params.page" :total="dataCount">
                        </el-pagination>

                        <div @click="toBannerNews" class="seeMoreClass">查看更多</div>
                    </div>


                </div>

                <!-- 资讯动态 -->
                <div class="informationClass">
                    <div class="topClass">
                        <div class="lableLeftClass">
                            <div v-for="item in policyLableList"
                                :class="['lableItemClass', policyLableIndex == item.name ? 'activeLable' : '']"
                                @click="policyLableClick(item)">{{ item.label }}</div>
                        </div>
                        <div v-if="false" class="moreClass">
                            <span>查看更多</span>
                        </div>
                    </div>

                    <div class="informationMain">
                        <div v-for="item in policyDataList" class="informationItem" @click="toPathDetail(item)">
                            <div class="informationTitle">{{ item.title }}</div>
                            <div v-if="false" class="tagClass">国家发展改革委</div>
                            <div class="otherInfo">
                                <span class="infoTime">{{ item.updateTime }}</span>
                                <span v-if="false" class="watchNum">12345人看过</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="suspensionClass">
            <div class="contactNumber commonClass">
                <div>联系电话</div>
                <div class="suspensionPhone">08332761005</div>
            </div>

            <div class="contactNumber commonClass">
                <div>管理办法</div>
                <div class="seeClass">
                    <a style="all: unset;color: inherit;"
                        href="https://lplb.oss-cn-chengdu.aliyuncs.com/share_oss/%E4%B9%90%E5%B1%B1%E5%B8%82%E6%B2%99%E6%B9%BE%E5%8C%BA%E5%8C%BA%E5%B1%9E%E5%9B%BD%E6%9C%89%E4%BC%81%E4%B8%9A%E9%9D%9E%E6%8B%9B%E6%A0%87%E9%A1%B9%E7%9B%AE(%E4%B9%99%E4%BE%9B%E6%9D%90)%E9%87%87%E8%B4%AD%E7%AE%A1%E7%90%86%E6%9A%82%E8%A1%8C%E5%8A%9E%E6%B3%95(%E8%AF%95%E8%A1%8C).pdf">
                        下载
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Message } from "element-ui";
import announcement from "@/api/announcement/announcement"
import home from "@/api/home/index"
import login from "@/api/login/login"

import purchaseTable from "../components/purchaseTable";
import correctTable from "../components/correctTable";
import resultTable from "../components/resultTable";

import newsTable from "../components/newsTable";
import lawTable from "../components/lawTable";
import downloadTable from "../components/downloadTable";
import listView from "../../components/list.vue";

import userView from "./user.vue";
import contactView from "./contact.vue";
import Images from "../../assets/images";

import NumberRoller from "../components/NumberRoller";
export default {

    data() {
        return {
            access_token: `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            tabPaneName: 6, //`${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`?'6':'7',
            dataLable: [
                // {
                //   lable:'入驻供应商数量',
                //   num:2345,
                //   color:'#E0941B',
                //   unit:'个',
                //   iSNumberFormat:false
                // },
                {
                    lable: '发包数量',
                    num: 0,
                    color: '#2D74C6',
                    unit: '个',
                    iSNumberFormat: false,
                    fractionDigits: 0
                }, {
                    lable: '发包总金额',
                    num: 0,
                    color: '#2FB7A7',
                    unit: '万元',
                    iSNumberFormat: true,
                    fractionDigits: 4
                }, {
                    lable: '成交金额',
                    num: 0,
                    color: '#8458DA',
                    unit: '万元',
                    iSNumberFormat: true,
                    fractionDigits: 4
                }, {
                    lable: '流标金额',
                    num: 0,
                    color: '#2D74C6',
                    unit: '万元',
                    iSNumberFormat: true,
                    fractionDigits: 4
                }
            ],
            tabPaneList: [
                // {
                //   name:1,
                //   label:'招标（采购）公告',
                //   icon:'',
                // },{
                //   name:2,
                //   label:'资讯预审公告',
                //   icon:'',
                // },{
                //   name:3,
                //   label:'中标结果公告',
                //   icon:'',
                // },
                {
                    name: 6,
                    label: '采购公告',
                    icon: '',
                    isLogin: true
                }, {
                    name: 7,
                    label: '采购结果公告',
                    icon: '',
                    isLogin: false
                }
                // ,{
                //   name:6,
                //   label:'更正公告',
                //   icon:'',
                // },{
                //   name:7,
                //   label:'其他采购公告',
                //   icon:'',
                // }
            ],
            bindCaFlag: false,
            banners: [],
            purchase: [],//采购公告
            correct: [],//更正公告
            list: [],//结果公告
            prequalification: [],//资格预审公告
            inquiry: [],//询价竞价公告
            resultPageData: [],//询价竞价结果公告
            params: {
                page: 1,
                limit: 6
            },
            dataList: [],
            statusList: {
                0: '未开始',
                1: '报名中',
                2: '已结束'
            },
            dataCount: 0,
            noticeList: [],// 通知公告
            policyLableIndex: 2,
            policyLableList: [
                {
                    name: 2,
                    label: '资讯动态'
                }, {
                    name: 3,
                    label: '政策法规'
                }
            ],
            policyDataList: [],//资讯动态 政策法规
            dictionaryData: {}

        };
    },
    // created() {
    //   this.orgInfo()
    // },
    mounted() {
        localStorage.setItem('TencentNews', 0)
        this.orgInfo()
        this.dictionary()
        this.statistics()
    },

    methods: {
        statistics() {
            home.statistics().then(res => {
                this.dataLable[0].num = res.data.packCount
                this.dataLable[1].num = res.data.totalPriceLimit / 10000 ?? 0 / 10000
                this.dataLable[2].num = res.data.totalBidderMoney / 10000 ?? 0 / 10000
                this.dataLable[3].num = res.data.flowStandardMoney / 10000 ?? 0 / 10000
            })
        },
        dictionary() {
            home.dictionary({ code: 'supplier' }).then(res => {
                this.dictionaryList = res.data
                let resData = {}
                res.data.forEach(element => {
                    resData[element.code] = element.value
                });
                this.dictionaryData = resData
            })
        },


        // 通知详情
        toNoticeDetail(item) {
            sessionStorage.setItem('noticeDetail', JSON.stringify(item))
            this.$router.push({
                path: "/detail",
                query: {
                    id: item.id,
                    type: 1
                }
            })
        },
        tabClick(data) {
            if (this.tabPaneName == data.name) {
                return
            }
            this.dataList = []
            this.params.page = 1
            this.tabPaneName = data.name
            this.getDataList()
        },
        policyLableClick(data) {
            this.policyLableIndex = data.name
            this.pageNewsLaw()
        },
        // 跳转解惑详情
        toDetail(path) {
            this.$router.push({ path: path })
        },
        toPathDetail(row) {
            this.$router.push({
                path: "/detail",
                query: {
                    id: row.id,
                    type: this.policyLableIndex,
                }
            })
        },
        toBannerNews() {
            this.$router.push({
                path: "/bannerNews",
            })
        },

        resultPage() {//询价竞价结果公告
            announcement.resultPage(this.params).then(res => {
                this.dataList = res.data.list
                this.dataCount = res.data.count
            })
        },

        // 竞价询价公告
        InquiryList() {
            announcement.queryPriceList({
                ...this.params,
                type: 6,
            }).then(res => {
                if (res.code == 0) {
                    this.dataList = res.data.list;
                    this.dataCount = res.data.count
                }
            })
        },


        getDataList() {
            if (this.tabPaneName == 6) {
                this.InquiryList()
            }
            if (this.tabPaneName == 7) {
                this.resultPage()
            }
        },

        onInfo(row) {
            sessionStorage.setItem("projectId", row.projectId);
            sessionStorage.setItem("bulletinId", row.id);
            // if(this.tabPaneName==6 && !this.access_token){
            //   Message.warning("请先登录");
            //   return
            // }
            let routeData = this.$router.resolve({
                path: "/purchase/info",
                query: {
                    noticeId: row.noticeId,
                    projectId: row.projectId,
                    type: this.tabPaneName,
                    id: row.id,
                },
            });
            window.open(routeData.href, "_blank");
        },
        //查询当前域名的公司信息window.location.host
        async orgInfo() {
            const res = await announcement.orgInfo({ domains: 'localhost' })
            // console.log("查询当前域名的公司信息", res)
            if (res.code == 0) {
                localStorage.setItem("orgInfo", JSON.stringify(res.data))
                this.queryBannerListByPosition()//轮播图
                this.pageNotice()
                this.getDataList()
                this.pageNewsLaw()
            }
        },
        //获取banner
        queryBannerListByPosition() {
            announcement.queryBannerListByPosition().then(res => {
                // console.log(res,'123456')
                this.banners = res.data
            })
        },


        // 资讯列表（最新） 政策列表（最新）type = 4
        pageNewsLaw() {
            let methodData = this.policyLableIndex == 2 ? home.pageNews : home.pageLaw

            methodData({
                page: 1,
                limit: 8
            }).then(res => {
                if (res.code == 0) {
                    this.policyDataList = res.data.list;
                }
            })
        },


        // 通知公告（最新）
        pageNotice() {
            home.pageNotice({
                page: 1,
                limit: 3
            }).then(res => {
                if (res.code == 0) {
                    this.noticeList = res.data.list;
                }
            })
        },

    },
    components: {
        purchaseTable,
        correctTable,
        resultTable,
        userView,
        contactView,
        newsTable,
        lawTable,
        downloadTable,
        listView,
        NumberRoller
    },
};
</script>

<style lang="less" scoped>
.suspensionClass {
    position: fixed;
    left: 10px;
    bottom: 20vh;
    background: #fff;
    width: 90px;
    height: auto;
    border-radius: 10px;
    padding: 10px 0;
    box-sizing: border-box;
    z-index: 99;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    box-shadow: inset 0 0 5px #0080FF;

    .commonClass {
        text-align: center;
        padding: 0px 5px;
        height: 40px;
        line-height: 40px;
        box-sizing: border-box;
        color: #aaa;
        position: relative;

        :hover {
            background: #000000;
            color: #fff;
            border-radius: 10px;
        }
    }

    .contactNumber {
        position: relative;

        .suspensionPhone {
            display: none;
            width: fit-content;
            height: auto;
            position: absolute;
            right: -120px;
            top: 0;
            padding: 0px 10px;
            box-sizing: border-box;
            box-shadow: inset 0 0 5px #fff;
            background: #000;
            border-radius: 5px;
            color: #fff;
        }

        .seeClass {
            display: none;
            width: fit-content;
            height: auto;
            position: absolute;
            right: -50px;
            top: 0;
            padding: 0px 10px;
            box-sizing: border-box;
            box-shadow: inset 0 0 5px #fff;
            background: #000;
            border-radius: 5px;
            color: #fff;
        }
    }

    .contactNumber:hover .suspensionPhone {
        display: block;
    }

    .contactNumber:hover .seeClass {
        display: block;
    }
}

.emptyClass {
    text-align: center;
    height: 100px;
    line-height: 100px;
    background: #F2FAFF;
    font-size: 20px;
    color: #999;
}

.multi-line {
    display: -webkit-box;
    /* 旧版弹性盒子模型 */
    -webkit-box-orient: vertical;
    /* 内容垂直排列 */
    -webkit-line-clamp: 1;
    /* 显示行数 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 显示省略号 */

    /* 可选：修复某些打包工具可能删除这个属性的问题 */
    /* autoprefixer: ignore next */
    -webkit-box-orient: vertical;
}

.contantMainClass {
    width: 85%;
    margin: 0 auto;
    margin-top: 20px;

    .informationClass {
        margin-top: 35px;
        width: 100%;

        .informationMain {
            margin-top: 20px;
            width: 100%;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 20px;

            .informationItem {
                height: 175px;
                background: #FFFFFF;
                border-radius: 5px;
                padding: 20px;
                box-sizing: border-box;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .otherInfo {
                    display: flex;
                    justify-content: space-between;
                    font-weight: 400;
                    font-size: 16px;
                    text-align: left;

                    .infoTime {
                        color: #999999;
                    }

                    .watchNum {
                        color: #767676;
                    }
                }

                .tagClass {
                    height: 35px;
                    background: rgba(255, 135, 1, 0.1);
                    border-radius: 3px;
                    border: 1px solid #FF8701;
                    box-sizing: border-box;
                    padding: 0 11px;
                    width: fit-content;
                    line-height: 35px;
                    font-weight: 400;
                    font-size: 16px;
                    color: #FF8701;
                }

                .informationTitle {
                    height: 57px;
                    font-family: Source Han Sans, Source Han Sans;
                    font-weight: 500;
                    font-size: 20px;
                    color: #3D3D3D;
                    line-height: 27px;
                    display: -webkit-box;
                    /* 旧版弹性盒子模型 */
                    -webkit-box-orient: vertical;
                    /* 内容垂直排列 */
                    -webkit-line-clamp: 2;
                    /* 显示行数 */
                    line-clamp: 2;
                    overflow: hidden;
                    /* 隐藏溢出内容 */
                    text-overflow: ellipsis;
                    /* 显示省略号 */
                    -webkit-box-orient: vertical;
                }

            }

            .informationItem:hover {
                background: #2F7BFF;

                .informationTitle {
                    color: #fff;
                }

                .otherInfo {
                    .infoTime {
                        color: #fff;
                    }
                }

            }
        }

        .topClass {
            width: 100%;
            height: 62px;
            background: #FFFFFF;
            border-radius: 5px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;

            box-sizing: border-box;

            .lableLeftClass {
                display: flex;
                align-items: center;
                font-weight: 500;
                font-size: 24px;
                color: #3D3D3D;
                padding-top: 20px;

                .lableItemClass {
                    margin-right: 60px;
                    font-weight: 500;
                    font-size: 24px;
                    color: #3D3D3D;
                    cursor: pointer;
                    padding-bottom: 5px;
                    border-bottom: 4px solid transparent;
                }

                .activeLable {
                    border-bottom: 4px solid #0080FF;
                }

            }

            .moreClass {
                display: flex;
                align-items: center;
                font-weight: 500;
                font-size: 16px;
                color: #767676;
                cursor: pointer;
            }
        }
    }

    .noticeContantClass {
        margin-top: 35px;
        width: 100%;
        background: #fff;
        padding: 25px 60px;
        box-sizing: border-box;

        .paginationClass {
            margin-top: 20px;
            display: flex;
            justify-content: center;
            align-items: center;

            .seeMoreClass {
                margin-left: 20px;
                font-weight: 400;
                font-size: 14px;
                color: #606266;
                cursor: pointer;
            }
        }

        .noticeInfoBoxClass {
            margin-top: 20px;
            width: 100%;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;

            .noticeItemBoxInfo {
                cursor: pointer;
                background: #F2FAFF;
                // height: 84px;
                padding: 18px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-radius: 5px;

                .statusBoxClass {
                    width: 93px;
                    height: 30px;
                    background: #DBEDFE;
                    border-radius: 5px;
                    line-height: 30px;
                    text-align: center;
                    font-weight: 400;
                    font-size: 14px;
                    color: #2F7BFF;
                    border-radius: 5px;
                }

                .statusBoxClass[data-status='2'] {
                    color: #fff;
                    background: #dddddd;
                }

                .leftBox {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    flex: 1;
                    padding-right: 30px;

                    .infoBox {
                        font-weight: 500;
                        font-size: 20px;
                        color: #3D3D3D;
                    }

                    .bottomClass {
                        display: flex;
                        align-items: center;
                        margin-top: 10px;

                        .tagClass {
                            display: inline-block;
                            background: rgba(255, 135, 1, 0.1);
                            border-radius: 5px;
                            border: 1px solid #FF8701;
                            box-sizing: border-box;
                            width: fit-content;
                            font-size: 14px;
                            color: #FF8701;
                            margin-right: 10px;
                            padding: 2px 5px;
                        }

                        .supportTagClass {
                            display: inline-block;
                            background: rgba(255, 135, 1, 0.1);
                            border-radius: 5px;
                            border: 1px solid #2f7bff;
                            box-sizing: border-box;
                            width: fit-content;
                            font-size: 14px;
                            color: #2f7bff;
                            margin-right: 10px;
                            padding: 2px 5px;
                        }

                    }

                    .timeBox {
                        font-weight: 500;
                        font-size: 14px;
                        color: #999999;
                    }
                }

            }

            .noticeItemBoxInfo:hover {
                background: #FFFFFF;
                box-shadow: 0px 4px 10px 0px #DBEDFE;
                border: 1px solid;
                border-image: linear-gradient(180deg, rgba(0, 128.0000075697899, 255, 0.3700000047683716), rgba(219.0000021457672, 237.0000010728836, 254.00000005960464, 1)) 1 1;
            }

            .noticeItemBoxInfo:hover .leftBox .infoBox {
                color: #2F7BFF;
            }

            .noticeItemBoxInfo:hover .statusBoxClass {
                background: #2F7BFF;
                color: #fff;
            }
        }

        .tabsBox {
            width: 100%;
            display: flex;
            // justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #EAEAEA;
            box-sizing: border-box;

            .tabsItemBox {
                display: flex;
                align-items: center;
                cursor: pointer;
                padding-bottom: 25px;
                border-bottom: 4px solid transparent;
                border-radius: 6px;
                margin-right: 60px;

                .lableClass {
                    font-weight: 500;
                    font-size: 20px;
                    color: #000000;
                    line-height: 20px;
                }

                img {
                    width: 21px;
                    height: 21px;
                    margin-right: 10px;
                }
            }

            .activeClass {
                border-bottom: 4px solid #0080FF;

                .lableClass {
                    color: #0080FF;
                }
            }
        }
    }

    .mainTop {
        width: 100%;
        display: flex;
        justify-content: space-between;

        .topLeft {
            width: 54.6%;
            background-color: #fff;
            display: flex;
            border-radius: 5px;

            img {
                cursor: pointer;
            }

            .noticeBoxClass {
                flex: 1;
                padding: 0 32px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .noticeItemClass {
                    padding: 16px 0;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    width: 100%;

                    .noticeItemInfo {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        flex: 1;
                        cursor: pointer;

                        .timeClass {
                            font-weight: 500;
                            font-size: 16px;
                            color: #999;
                            padding-left: 20px;
                            width: 160px !important;
                            text-align: right;
                            box-sizing: border-box;
                            white-space: nowrap;
                        }

                        .infoClass {
                            font-family: Source Han Sans, Source Han Sans;
                            font-weight: 500;
                            font-size: 18px;
                            color: #3D3D3D;
                        }
                    }

                    .dotClass {
                        width: 10px;
                        height: 10px;
                        background: #d51900;
                        border-radius: 100%;
                        margin-right: 15px;
                    }
                }
            }

        }

        .topRight {
            width: 42.4%;
            background-color: #fff;
            display: flex;
            justify-content: space-between;
            border-radius: 5px;
            padding: 0 20px;
            box-sizing: border-box;

            .dataItem {
                display: flex;
                justify-content: center;
                flex-direction: column;

                .dataNum {
                    font-weight: 900;
                    font-size: 24px;
                }

                .dataTitle {
                    margin-bottom: 10px;
                    display: flex;
                    align-items: center;

                    img {
                        width: 24px;
                        height: 24px;
                        margin-right: 6px;
                        border-radius: 100%;
                    }

                    .title {
                        font-weight: 600;
                        font-size: 15px;
                        color: #111111;
                    }
                }
            }
        }
    }
}





















.ch-container {
    // width: 1460px !important;
}

.main {
    margin: -20px;
    background-color: #F3F7FD;
    padding-bottom: 40px;
}

.ch-container-news {
    // width: 1200px;
    width: 85%;
    margin: 0 auto;
    padding-left: 15% !important;
    // margin-left: 27vh !important;
}

.release-time {
    color: #9a9a9a;
    font-size: 14px;
}

.ch-card-title {
    font-size: 20px;
}

/deep/ .el-tabs__item {
    font-size: 18px !important;
}

/deep/ .el-table td,
/deep/ .el-table th.is-leaf,
/deep/ .el-table::before {
    border-bottom: 0;
    z-index: 0 !important;
}

/deep/ .el-table td,
/deep/ .el-table th {
    padding: 11px 0;
}

.toolBox {
    padding: 30px 20px;
    display: flex;
    justify-content: space-between;
    // background-color: rgba(255, 255, 255, 0.3);
    // margin-top: -140px;
    z-index: 10000;

    .toolSignle {
        display: flex;
        align-items: center;
        width: fit-content;
        cursor: pointer;
        margin: 0;

        img {
            width: 50px;
            background-color: #fff;
            padding: 15px;
            border-radius: 10px;
        }
    }

    .toolContent {
        margin-left: 10px;
        height: 75%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
}

.go {
    background-image: linear-gradient(to right, #df2b13, #eb533e, #f47363, #f89287, #f9b0aa);
    width: fit-content;
    padding: 5px;
    border-radius: 15px;
    color: #fff;
}

/deep/.news {
    padding-top: 40px;
    background: url(../../assets/images/login_background.png) no-repeat 100% 100%;
    background-size: 100%;
    box-sizing: border-box;

    .cover {
        box-sizing: border-box;
        width: 100%;
        background-color: rgba(255, 255, 255, 0.8);
        padding: 40px 0 40px;

        .el-row {
            // padding: 0 20px;

            .el-card__header {
                padding: 0;
                box-sizing: border-box;

                .clearfix {
                    padding: 18px 20px;
                    box-sizing: border-box;

                    .ch-card-title {
                        padding: 16px 0;
                        border-bottom: 4px solid #DE2C15;
                    }
                }
            }

            .el-card {
                min-height: 300px;
                max-height: 300px;
            }
        }
    }



}

.el-card {
    background-color: #F9F9F9;
    min-height: 250px;

}

// .el-col-8{
//   width: 40% !important;
// }
.headerBox-news {
    width: 420px;
    // width: 22%;
    //  background-color: pink;
}

.headerBox-cover {
    width: 490px;
    // width: 22%;
    // margin-left: 300px;
    //  background-color: pink;
}

.right-headerBox-news {
    width: 5%;
    // background-color: pink;
}

.left-cover {
    width: 5%;
}

.notice {
    // padding: 30px 0px 30px 40px;
    padding: 30px 20px;
    background-color: #fff;
    display: flex;
    flex-shrink: 0;
    // justify-content: space-between;
    // width: 355vh;
    // margin: 0 350px;

    .n_title {
        background-image: linear-gradient(to right bottom, #fd5c4c, #f44e3c, #ea3f2b, #e02e18, #d51900);
        padding: 15px;
        color: #fff;
        width: fit-content;
        flex-shrink: 0;
    }

    .n_Item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #F9F8F6;
        cursor: pointer;
        line-height: 1.5;
        padding: 10px 10px 10px 18px;
        width: 100%;

        .n_content {
            display: flex;
            justify-content: space-between;
            width: 375px;

            .n_Name {
                display: -webkit-box;
                /* 将文本显示为块元素 */
                -webkit-line-clamp: 2;
                /* 设置最大显示行数为2 */
                -webkit-box-orient: vertical;
                /* 设置块元素内部文本垂直排列 */
                overflow: hidden;
                /* 当文本溢出块元素时进行隐藏 */
                text-overflow: ellipsis;
                /* 溢出部分显示省略号 */
            }

            .n_Tag {
                background-image: linear-gradient(to bottom, #fd5c4c, #f44e3c, #ea3f2b, #e02e18, #d51900);
                margin-left: 10px;
                font-size: 12px;
                padding: 0 5px;
                line-height: 2;
                color: #fff;
                border-radius: 6px;
            }
        }

        .n_Time {
            color: #B2B0B1;
            width: 65%;
            // padding-right: 50px;
            padding-left: 18px;
            // background-color: pink;
            border-right: 1px solid rgb(178, 176, 177);
        }
    }

    .n_Item:last-of-type {

        .n_Time {
            border: 0;
        }
    }
}



.no_tender {
    background-color: #fff;
    padding: 50px 20px 0;

    .rightImg {
        img {
            width: 200px;
            height: 354px;
            object-fit: cover;
        }
    }

    /deep/.nt_header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        .nt_title {
            font-size: 20px;
            font-weight: 600;
        }

        .nt_h_left {
            display: flex;
            align-items: center;

            .el-tabs__header {
                margin: 0;

                .el-tabs__item.is-active {
                    // background-image: linear-gradient(to right bottom, #fd5c4c, #f44e3c, #ea3f2b, #e02e18, #d51900);
                    color: #fff;
                    border: 0;
                }
            }

            .el-tabs__nav-wrap::after {
                display: none;
            }

            .el-tabs__active-bar {
                display: none;
            }

            .el-tabs__item {
                height: unset;
                line-height: unset;
                padding: 5px;
                font-size: 12px;
                border-radius: 4px;
                margin: 0 15px;
            }

            .el-tabs__item:hover {
                color: #d51900;
                cursor: pointer;
                border: 0;
            }
        }
    }
}

.tender {
    background-color: #F9F8F6;

    /deep/.t_header {
        display: flex;
        align-items: flex-start;
        padding-bottom: 20px;

        .headerBox {
            width: 350px;
            height: 395px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            flex-shrink: 0;
            background: url(../../assets/images/login_background.png) 100% 100%;

            .t_title {
                font-size: 20px;
                font-weight: 600;
                margin: 15px;
            }

            .tederHeadBox {
                padding: 15px 20px;
            }

            .tederHeadBox:hover {
                background-image: linear-gradient(to right, #efedee, #f3f2f2, #f7f6f7, #fbfbfb, #ffffff);
                cursor: pointer;
            }

            .is_active {
                background-image: linear-gradient(to right, #efedee, #f3f2f2, #f7f6f7, #fbfbfb, #ffffff);
            }
        }



        .t_h_left {
            // display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;

            .el-tabs__header {
                margin: 0;

                .el-tabs__item.is-active {
                    background-image: linear-gradient(to right bottom, #fd5c4c, #f44e3c, #ea3f2b, #e02e18, #d51900);
                    color: #fff;
                    border: 0;
                }
            }

            .el-tabs__nav-wrap::after {
                display: none;
            }

            .el-tabs__active-bar {
                display: none;
            }

            .el-tabs__item {
                height: unset;
                line-height: unset;
                padding: 5px;
                font-size: 12px;
                border-radius: 4px;
                margin: 0 5px;
            }

            .el-tabs__item:hover {
                color: #d51900;
                cursor: pointer;
                border: 0;
            }
        }
    }
}

.banner_tool {
    position: relative;

    .tool {
        position: absolute;
        bottom: 0;
        z-index: 1000;
    }
}

/deep/.el-image {
    height: unset !important;
    object-fit: cover;
}
</style>